import { Option } from "@opendaw/lib-std";
export var AblPattern;
(function (AblPattern) {
    /**
     * MIDI note for the plugin's pitch 0. VERIFIED twice against captured plugin state: decoding the
     * `scream` and `userlab` banks with this base reproduces their known note sequences exactly.
     *
     * NOT the Cubed step default of 60 - using that loads every pattern two octaves high.
     */
    AblPattern.BASE_NOTE = 36;
    const NOTE_NAMES = {
        c: 0, "c#": 1, d: 2, "d#": 3, e: 4, f: 5, "f#": 6, g: 7, "g#": 8, a: 9, "a#": 10, b: 11
    };
    /** `a#3` / `c-5` -> MIDI note. The `-` is a placeholder for "no accidental", not a minus sign. */
    const parseNoteName = (text) => {
        const match = text.toLowerCase().match(/^([a-g][#-]?)(-?\d+)$/);
        if (match === null) {
            return Option.None;
        }
        const semitone = NOTE_NAMES[match[1].replace("-", "")];
        if (semitone === undefined) {
            return Option.None;
        }
        // The named octave maps directly, which puts the plugin's base note (pitch 0 = MIDI 36) at
        // `c-3` and middle C at `c-5` - consistent with the verified ABL3 base.
        const note = semitone + parseInt(match[2], 10) * 12;
        return note >= 0 && note <= 127 ? Option.wrap(note) : Option.None;
    };
    const flag = (text) => text !== undefined && parseInt(text, 10) !== 0;
    AblPattern.parse = (text) => {
        const steps = [];
        for (const raw of text.split(/\r?\n/)) {
            const line = raw.trim();
            if (line.length === 0 || line.startsWith(";")) {
                continue;
            }
            const columns = line.split(/\s+/);
            const named = parseNoteName(columns[0]);
            if (named.nonEmpty()) {
                // ABL2: note gate accent slide
                steps.push({
                    note: named.unwrap(),
                    active: flag(columns[1]),
                    accent: flag(columns[2]),
                    slide: flag(columns[3])
                });
                continue;
            }
            const pitch = parseInt(columns[0], 10);
            if (!Number.isFinite(pitch)) {
                continue;
            }
            // ABL3: pitch down up accent slide gate. Pitch is a semitone offset from the plugin's
            // BASE NOTE, and the down/up flags shift it an octave.
            const octave = (flag(columns[2]) ? 12 : 0) - (flag(columns[1]) ? 12 : 0);
            const note = AblPattern.BASE_NOTE + pitch + octave;
            steps.push({
                note: Math.max(0, Math.min(127, note)),
                accent: flag(columns[3]),
                slide: flag(columns[4]),
                active: flag(columns[5])
            });
        }
        return { steps, length: steps.length };
    };
})(AblPattern || (AblPattern = {}));
